/**
 * Generated from TrashCollectOutroLayout.fla
 */
export function TrashCollectOutroLayout(this: ITrashCollectOutroLayout) {
	const bg = this.bg;
	TrashCollectOutroLayout_bg.call(this.bg);
	bg.x = 375.6;
	bg.y = 459.95;
	bg.width = 2462.64;
	bg.height = 1136.58;
	if (bg.onLayout) bg.onLayout();
	const homeButton = this.homeButton;
	TrashCollectOutroLayout_homeButton.call(this.homeButton);
	homeButton.x = 108;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const grover = this.grover;
	TrashCollectOutroLayout_grover.call(this.grover);
	grover.x = 740.2;
	grover.y = 626.15;
	grover.width = 226.81;
	grover.height = 457.93;
	if (grover.onLayout) grover.onLayout();
	const oscar = this.oscar;
	TrashCollectOutroLayout_oscar.call(this.oscar);
	oscar.x = 324.7;
	oscar.y = 629.8;
	oscar.width = 219.60;
	oscar.height = 398.99;
	if (oscar.onLayout) oscar.onLayout();
	const skipButton = this.skipButton;
	TrashCollectOutroLayout_skipButton.call(this.skipButton);
	skipButton.x = 946.25;
	skipButton.y = 687.75;
	skipButton.width = 156.50;
	skipButton.height = 161.50;
	if (skipButton.onLayout) skipButton.onLayout();
	return this;
}
function TrashCollectOutroLayout_bg(this: ITrashCollectOutroLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bg.png", 0.281, 0.681);
	return this;
}
function TrashCollectOutroLayout_homeButton(this: ITrashCollectOutroLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function TrashCollectOutroLayout_grover(this: ITrashCollectOutroLayout_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("Grover-wave.png", 0.531, 0.972);
	return this;
}
function TrashCollectOutroLayout_oscar(this: ITrashCollectOutroLayout_oscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("Oscar-3.png", 0.503, 0.980);
	return this;
}
function TrashCollectOutroLayout_skipButton(this: ITrashCollectOutroLayout_skipButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("skip-btn.png", 0.500, 0.500);
	return this;
}
interface ITrashCollectOutroLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ITrashCollectOutroLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ITrashCollectOutroLayoutSprite extends ITrashCollectOutroLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ITrashCollectOutroLayoutText extends ITrashCollectOutroLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ITrashCollectOutroLayoutPolygon extends Array<number> {
}
interface ITrashCollectOutroLayout {
	readonly bg: ITrashCollectOutroLayout_bg;
	readonly homeButton: ITrashCollectOutroLayout_homeButton;
	readonly grover: ITrashCollectOutroLayout_grover;
	readonly oscar: ITrashCollectOutroLayout_oscar;
	readonly skipButton: ITrashCollectOutroLayout_skipButton;
}
interface ITrashCollectOutroLayout_bg extends ITrashCollectOutroLayoutSprite {
}
interface ITrashCollectOutroLayout_homeButton extends ITrashCollectOutroLayoutSprite {
}
interface ITrashCollectOutroLayout_grover extends ITrashCollectOutroLayoutSprite {
}
interface ITrashCollectOutroLayout_oscar extends ITrashCollectOutroLayoutSprite {
}
interface ITrashCollectOutroLayout_skipButton extends ITrashCollectOutroLayoutSprite {
}
